export default "<mat-checkbox [checked]=\"active\" class=\"observe-trigger\" (change)=\"trigger($event)\">\r\n    Abordé\r\n</mat-checkbox>"